import { request } from '@services'
import cloneDeep from 'lodash/cloneDeep'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getMeasureList(state) {
    return state.data
  },
  getMeasureListById(state) {
    const data =
      cloneDeep(state.data)?.list.map((item) => {
        item.device_name = item.device_name ? item.device_name : '手動'
        item.athlete = item.athlete === 0 ? 'off' : 'on'
        item.weight = parseFloat(item.data.weight).toFixed(2) + 'kg'
        item.BMI = parseFloat(item.data.BMI).toFixed(1)
        item.body_fat_rate =
          parseFloat(item.data.body_fat_rate).toFixed(1) + '%'
        item.lean_body_weight =
          parseFloat(item.data.lean_body_weight).toFixed(2) + 'kg'
        item.subcutaneous_fat =
          parseFloat(item.data.subcutaneous_fat).toFixed(1) + '%'
        item.visceral_fat = parseFloat(item.data.visceral_fat).toFixed(0)
        item.body_water_rate =
          parseFloat(item.data.body_water_rate).toFixed(1) + '%'
        item.muscle_rate = parseFloat(item.data.muscle_rate).toFixed(1) + '%'
        item.muscle_mass = parseFloat(item.data.muscle_mass).toFixed(2) + 'kg'
        item.protein = parseFloat(item.data.protein).toFixed(2) + '%'
        item.BMR = parseFloat(item.data.BMR).toFixed(0) + 'kcal'
        item.metabolic_age = parseFloat(item.data.metabolic_age).toFixed(0)
        item.bone_mass = parseFloat(item.data.bone_mass).toFixed(2) + 'kg'
        return item
      }) || []
    return data
  },
}

export const mutations = {
  SET_MEASURE_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_MEASURE_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_MEASURE_LIST_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_MEASURE_LIST(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingMeasureList({ commit }, params) {
    commit('SET_MEASURE_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/measure/list/',
        payload: { ...params },
      })
      commit('SET_MEASURE_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_MEASURE_LIST_RECEIVED_FAILED', error)
    }
  },
  resetMeasureList({ commit }) {
    commit('RESET_MEASURE_LIST')
  },
  async deleteMeasureById({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/measure/delete/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
  async exportMeasureCsv({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/measure/export/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
}
